import { render, staticRenderFns } from "./androidRedirect.vue?vue&type=template&id=0f39ea45&"
import script from "./androidRedirect.vue?vue&type=script&lang=ts&"
export * from "./androidRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports